import { Directive, effect, input, signal } from '@angular/core'

import { theme } from '@flowx/core-sdk'
import { SeparatorStyles, applySeparatorCustomStyles } from '@flowx/core-theme'

@Directive({
  selector: 'flx-separator',
  exportAs: 'flxSeparatorStyle',
  standalone: true,
})
export class FlxSeparatorStyleDirective {
  componentStyle = input<{
    style: SeparatorStyles
  }>()

  styleClassName = signal<string>('')

  constructor() {
    effect(async () => {
      const className = await applySeparatorCustomStyles(this.componentStyle().style, theme())
      this.styleClassName.set(className)
    })
  }
}
